module.exports = __webpack_public_path__ + "img/logosttritauna.2bf6e7a1.png";